import {
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type
} from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
const DEFAULTS = Object.freeze({
  config: {
    alignment: "center",
    size: "content",
    showTitle: true,
    showDescription: true
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    textWrap: true
  }
});
const PLUGIN_TOOLBAR_BUTTON_ID_IMAGE_EDITOR = "image-editor";
const PLUGIN_TOOLBAR_BUTTON_ID_SET_AS_BANNER = "image-set-as-banner";
const PLUGIN_TOOLBAR_BUTTON_ID_SET_AS_FOOTER = "image-set-as-footer";
const IMAGE_SETTINGS_MODAL_ID = "IMAGE.settings";
const IMAGE_EDITOR_MODAL_ID = "IMAGE.imageEditor";
const IMAGE_EDITOR_COLOR_PICKER_MODAL_ID = "IMAGE.imageEditor.colorPicker";
const IMAGE_BUTTONS = {
  size: `${Node_Type.IMAGE}.size`,
  alignment: `${Node_Type.IMAGE}.alignment`
};
export {
  DEFAULTS,
  IMAGE_BUTTONS,
  IMAGE_EDITOR_COLOR_PICKER_MODAL_ID,
  IMAGE_EDITOR_MODAL_ID,
  IMAGE_SETTINGS_MODAL_ID,
  PLUGIN_TOOLBAR_BUTTON_ID_IMAGE_EDITOR,
  PLUGIN_TOOLBAR_BUTTON_ID_SET_AS_BANNER,
  PLUGIN_TOOLBAR_BUTTON_ID_SET_AS_FOOTER,
  RICOS_DEFAULTS
};
//# sourceMappingURL=consts.js.map
